export default __webpack_public_path__ + "ca13936b3eec444075049ffea7f777b0.png";